import { InternalServerErrorException } from '../../../common/exceptions/exceptions';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetSelfTimeInCallsScoreService } from '../../../core/application/services/scores/get-self-time-in-calls-score.service';
import { SelfTimeInCallsScoreAggregateRoot } from '../../../core/domain/aggregates/scores/self-time-in-calls-score.aggregate-root';
import { GetSelfAllScoresRequestDto } from '../../dtos/scores/self-get-all-scores.request.dto';

export class GetSelfTimeInCallsScoreQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetSelfTimeInCallsScoreService
  ) {}
  async execute(
    props: GetSelfAllScoresRequestDto
  ): Promise<SelfTimeInCallsScoreAggregateRoot> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
